import { render, staticRenderFns } from "./AdminBollettazione.vue?vue&type=template&id=095d0073"
import script from "./AdminBollettazione.vue?vue&type=script&lang=js"
export * from "./AdminBollettazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports